import { render, staticRenderFns } from "./BrowseToFileSettings.vue?vue&type=template&id=6aefcdae&scoped=true"
import script from "./BrowseToFileSettings.vue?vue&type=script&lang=ts"
export * from "./BrowseToFileSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aefcdae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aefcdae')) {
      api.createRecord('6aefcdae', component.options)
    } else {
      api.reload('6aefcdae', component.options)
    }
    module.hot.accept("./BrowseToFileSettings.vue?vue&type=template&id=6aefcdae&scoped=true", function () {
      api.rerender('6aefcdae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/BrowseToFileSettings.vue"
export default component.exports